export const ORDERLIST = 'ORDERLIST'
export const ORDERCOMP = 'ORDERCOMP'
export const ORDERWAYBILL = 'ORDERWAYBILL'
export const PROD_LOAD = 'PROD_LOAD'
export const REFUNDLIST = 'REFUNDLIST'
export const REFUND_LOAD = 'REFUND_LOAD'
export const CURRENCY_OBJ = 'CURRENCY_OBJ'
export const COIN_OBJ = 'COIN_OBJ'
